import { render, staticRenderFns } from "./TextSegment.vue?vue&type=template&id=a3588ef0&"
import script from "./TextSegment.vue?vue&type=script&lang=js&"
export * from "./TextSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports